import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const EmailCaptureModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "mlp-email-capture" */
            './EmailCapture'
        )
    ),
    componentName: 'EmailCapture',
    placeholder: {
        placeholderType: 'Block',
        size: 'smd',
    },
});
export default EmailCaptureModule;
